import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// custom components
import * as Layout from "common/layout";
import CourseBanner from "./CourseBanner";
import CourseClasses from "./CourseClasses";

// styling
const { PageContent } = Layout;

const BookACourse = () => {
  const [currentCourseId, setCurrentCourseId] = useState<number | undefined>(
    undefined
  );

  const [mounted, setMounted] = useState(false);
  const location = useLocation();
  const { t } = useTranslation("book_a_course");

  // make use of ComponentWillMount to initiate states for CourseBanner
  if (!mounted) {
    const { state }: { state: any } = location;
    if (state?.course) {
      setCurrentCourseId(state.course.id);
      setMounted(true);
    }
  }

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    document.title = t("LTL Flexi Classes - Full Courses");
  });

  return (
    <PageContent>
      <CourseBanner
        currentCourseId={currentCourseId}
        setCurrentCourseId={setCurrentCourseId}
      />
      <CourseClasses currentCourseId={currentCourseId} />
    </PageContent>
  );
};

export default BookACourse;
